<template>
  <base-section
    id="basuppgifter-section"
    heading="Basuppgifter"
    :infoStatus="basuppgifter.infoStatus"
    :show-error="!!basuppgifter.error"
  >
    <section-row title="Ålder" :value="basuppgifter.data.alder" />
    <avtalat-spinner v-if="basuppgifter.isLoading" />
    <div
      v-for="(anstallning, index) in basuppgifter.data?.anstallningar.filter(
        (item) => item.isAktiv,
      )"
      :key="index"
    >
      <div id="basuppgifter-content" class="basuppgifter-content">
        <div class="type-body-sm">
          <strong>{{ anstallning.arbetsgivareNamn }}</strong>
          <span v-if="anstallning.isPremiebefriad"> (Premiebefriad)</span>
        </div>
        <section-row
          v-if="anstallning?.anmaldArslon !== null"
          title="Anmäld årslön"
          :subTitle="`(${anstallning.anmaldLonGiltigFrom})`"
          :value="formattedAmountInCurrency(anstallning?.anmaldArslon)"
          :value-is-numeric="true"
          :help-text="helpTexts.basuppgifter.anmaldArslon"
        />
        <section-row
          v-if="anstallning?.anmaldLon !== null"
          title="Anmäld lön"
          :subTitle="`(${anstallning.anmaldLonGiltigFrom})`"
          :value="formattedAmountInCurrency(anstallning?.anmaldLon)"
          :value-is-numeric="true"
          :help-text="helpTexts.basuppgifter.anmaldLon"
        />
        <section-row
          v-if="anstallning?.efterskyddslon !== null"
          title="Efterskyddslön"
          :subTitle="`(${anstallning.anmaldLonGiltigFrom})`"
          :value="formattedAmountInCurrency(anstallning?.efterskyddslon)"
          :value-is-numeric="true"
          :help-text="helpTexts.basuppgifter.efterskyddslon"
        />
        <section-row
          title="Pensionsmedförande lön"
          :value="formattedAmountInCurrency(anstallning.pensionsmedforandeLon)"
          :value-is-numeric="true"
          :help-text="helpTexts.basuppgifter.pensionsmedforandeLon"
        />
        <section-row
          title="Sjukpensionsgrundande lön"
          :value="
            formattedAmountInCurrency(anstallning.sjukpensionsgrundandeLon)
          "
          :value-is-numeric="true"
        />
        <section-row
          title="Pensionsplan"
          :value="anstallning?.pensionsplansnamn"
        />
        <section-row
          v-if="anstallning?.pensionsalder !== null"
          title="Pensionsålder"
          :value="anstallning?.pensionsalder"
        />
        <section-row
          v-if="
            anstallning.uauStartdatum &&
            anstallning.uauSlutdatum.length === 0 &&
            anstallning.uauTyp &&
            anstallning.uauTyp !== UauType.Okand
          "
          :title="uauTypeToString(anstallning.uauTyp)"
          :value="anstallning.uauStartdatum"
        />
      </div>
    </div>
  </base-section>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { BaseSection, SectionRow } from "@/components/sections";
import { UauType } from "@/composables/KundserviceAppApiClient";
import helpTexts from "@/config/helpTexts";
import { useIndividStore } from "@/stores";
import {
  formattedAmountInCurrency,
} from "@/common/formatters";

import { useAnstalldStore } from "../store";

const individStore = useIndividStore();
const anstalldStore = useAnstalldStore();

const basuppgifter = computed(() => {
  if (individStore.individ.isLoading || anstalldStore.basuppgifter.isLoading) {
    return {
      isLoading: true,
      infoStatus: [],
      data: {
        anstallningar: [],
        alder: null,
      },
      error: null,
    };
  }

  return {
    isLoading: false,
    infoStatus: anstalldStore.basuppgifter.infoStatus,
    data: {
      alder: anstalldStore.basuppgifter.data?.alder,
      anstallningar:
        anstalldStore.basuppgifter.data?.basuppgifterList?.map((x) => ({
          ...x,
          arbetsgivareNamn: x.arbetsgivareNamn ?? "-",
        })) ?? [],
    },
    error: anstalldStore.basuppgifter.error,
  };
});

const uauTypeToString = (uauType?: UauType) => {
  if (!uauType) {
    return "-";
  }
  switch (uauType) {
    case UauType.Avstaende:
      return "Avstående";
    case UauType.Undantag:
      return "Undantag";
    case UauType.Uttrade:
      return "Utträde";
  }
  return "-";
};
</script>

<style>
.basuppgifter-content {
  position: relative;
  margin-top: 2rem;
}
</style>
